import React from 'react';
import { Box } from '@mui/material';
import hosannaLogo from '../../assets/hosanna_logo.png';

function AuthLogo({ maxWidth = 200, maxHeight = 200 }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
      <Box
        component="img"
        src={hosannaLogo}
        alt="Hosanna Logos"
        sx={{
          maxWidth: `${maxWidth}px`,
          maxHeight: `${maxHeight}px`,
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
}

export default AuthLogo;

